const HisFolderClock = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg  style={_sx} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.35938 20.2085H4.35938C3.82894 20.2085 3.32023 19.9978 2.94516 19.6227C2.57009 19.2476 2.35938 18.7389 2.35938 18.2085V5.2085C2.35938 4.1085 3.25937 3.2085 4.35938 3.2085H8.28937C8.61879 3.2102 8.94268 3.29325 9.23228 3.45026C9.52187 3.60726 9.7682 3.83337 9.94938 4.1085L10.7694 5.3085C10.9506 5.58362 11.1969 5.80973 11.4865 5.96674C11.7761 6.12375 12.1 6.20679 12.4294 6.2085H20.3594C20.8898 6.2085 21.3985 6.41921 21.7736 6.79428C22.1487 7.16936 22.3594 7.67806 22.3594 8.2085"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3594 22.2085C19.6731 22.2085 22.3594 19.5222 22.3594 16.2085C22.3594 12.8948 19.6731 10.2085 16.3594 10.2085C13.0457 10.2085 10.3594 12.8948 10.3594 16.2085C10.3594 19.5222 13.0457 22.2085 16.3594 22.2085Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3594 14.2085V16.2085L17.3594 17.2085"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisFolderClock;
